import { Library } from 'lucide-react'
import type { ReactNode } from 'react'
import { AuthoredIcon } from '@/components/admin/shared/authored-icon'
import {
  containerFallbackIcon,
  leafKindIcon,
} from '@/components/admin/shared/kind-icons'
import type { CatalogLearningItemKind } from '@/lib/coaching/learning-item-projection'

const ICON_CLASS = 'h-3.5 w-3.5 shrink-0 text-(--cd-text-faint)'
// Same mark/colour as ICON_CLASS but without the size — AuthoredIcon's
// `size="sm"` owns sizing for both the authored icon and its fallback, so
// the size utilities here would only fight it.
const FALLBACK_ICON_CLASS = 'shrink-0 text-(--cd-text-faint)'

/** The authored source icon, or a generic library mark. */
export function SourceHeadingIcon({
  icon,
}: {
  icon: string | null
}): ReactNode {
  return (
    <AuthoredIcon
      icon={icon}
      size="sm"
      className={FALLBACK_ICON_CLASS}
      fallback={Library}
    />
  )
}

/** The authored container icon, or a mark derived from its free-text kind. */
export function ContainerRowIcon({
  icon,
  kind,
}: {
  icon: string | null
  kind: string
}): ReactNode {
  const Fallback = containerFallbackIcon(kind)
  return (
    <AuthoredIcon
      icon={icon}
      size="sm"
      className={FALLBACK_ICON_CLASS}
      fallback={Fallback}
    />
  )
}

/**
 * Leaf rows have no icon of their own — a membership points at a catalog item
 * rather than carrying presentation — so the kind is all there is to go on.
 */
export function LeafRowIcon({
  kind,
}: {
  kind: CatalogLearningItemKind
}): ReactNode {
  const Icon = leafKindIcon(kind)
  return <Icon aria-hidden="true" className={ICON_CLASS} />
}
